<template>
    <div>
      <!--Header Components-->
      <base-header class="mt-4 pb-6" type=""/>
      <!--Main Container Cards-->
      <b-container fluid class="mt--6 container-padding">
        <div>
            <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
        </div>
        <b-row>
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header">
                    <b-row>
                        <b-col lg="6">
                            <h3>{{title}}</h3>
                        </b-col>
                    </b-row>
                </div>
                <b-row>
                  <b-col :md = "4">
                    <label class="form-control-label">{{language_terms['CUSTOMER']}}</label>
                      <multiselect
                        :disabled="!is_editing"
                        v-model="form.contact_name"
                        id="ajax"
                        label="name"
                        track-by="id"
                        :custom-label="customerNameWithCode"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :options="customers"
                        :multiple="false"
                        :searchable="true"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="300"
                        :limit="50"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="false"
                        @search-change="asyncFindCustomer"
                        @input="onSelectCustomer"
                      >
                      </multiselect>
                  </b-col>
                  <b-col md="3">
                    <base-input :label="language_terms['DATE']">
                      <flat-picker
                        :disabled="!is_editing"
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        style="background-color: white"
                        class="form-control datepicker"
                        v-model="form.date">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="3">
                    <base-input
                      :label="language_terms['REFERENCE']" :placeholder="language_terms['REFERENCE']" v-model="form.reference" :disabled="!is_editing"></base-input>
                  </b-col>
                  <b-col md="2">
                    <base-input :label="language_terms['CURRENCY']">
                      <el-select v-model="form.currency_code" filterable :disabled="!is_editing" @change="onSelectCurrency">
                          <el-option v-for="option in currency_options"
                              :key="option.code"
                              :label="option.code"
                              :value="option.code">
                          </el-option>
                      </el-select>
                  </base-input>
                </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <base-input label="Remarks (Customer to See)">
                      <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="form.remarks" :disabled="!is_editing"> </textarea>
                    </base-input>
                  </b-col>
                  <b-col md="6">
                    <!-- <base-input :label="language_terms['INTERNAL_REMARKS']"> -->
                    <base-input label="Remarks (Within Company)">
                      <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="form.remarks_internal" :disabled="!is_editing"></textarea>
                    </base-input>
                  </b-col>
                </b-row>
              </card>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="form.contact_name">
          <b-col cols="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col cols="8">
                        <h3>{{language_terms["DEBIT_NOTE_ITEMS"] }}</h3>
                    </b-col>
                  </b-row>
                </div>
                <!-- ITEMS START -->
                <b-row>
                  <b-col md="4">
                      <label class="form-control-label">{{language_terms['INVOICE_NO']}}</label>
                      <multiselect
                              :disabled="!is_editing"
                              class="mt-1"
                              :custom-label="invoiceNameWithCode"
                              v-model="row.code"
                              label="name"
                              placeholder="Type to search"
                              open-direction="bottom"
                              :options="invoices"
                              :multiple="false"
                              :searchable="true"
                              :clear-on-select="false"
                              :close-on-select="true"
                              :options-limit="300"
                              :limit="50"
                              :max-height="600"
                              :show-no-results="false"
                              :hide-selected="true"
                              @search-change="asyncFindInvoices"
                              @select="onSelectInvoice"
                          >
                      </multiselect>
                  </b-col> 
                  <b-col md="2">
                    <!-- <base-input :label="language_terms['INVOICE_AMOUNT']"  v-model="row.invoice_amount" disabled></base-input> -->
                    <base-input :value="(row.invoice_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled :label="language_terms['INVOICE_AMOUNT']" ></base-input>
                  </b-col>
                  <b-col md="2">
                    <base-input :value="(row.amount_paid * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled :label="language_terms['AMOUNT_PAID']" ></base-input>
                  </b-col>
                  <b-col md="3">
                    <base-input :label="language_terms['AMOUNT']" v-model="row.amount" type="NUMBER" :disabled="!is_editing"></base-input>
                  </b-col>
                  <b-col md="1" class="mt-4" v-if="(form.items.length == 0)">
                      <b-button variant="primary" @click="onClickAddItem()" class="mt-2"  v-if="(is_editing)">{{language_terms['ENTER']}}</b-button>
                  </b-col>
                  <b-col v-if="(form.items.length > 0)">
                        <b-table-simple striped hover responsive>
                            <b-thead head-variant="light">
                              <tr>  
                                  <th>{{language_terms['INVOICE_#']}}</th>
                                  <!-- <th>{{language_terms['CURRENCY_CODE']}}</th> -->
                                  <th>{{language_terms['INVOICE_AMOUNT']}}</th>
                                  <th>{{language_terms['BALANCE']}}</th>
                                  <th>{{language_terms['AMOUNT']}}</th>
                                  <th></th>
                              </tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(row, index) in form.items" :key="index">
                                  <td>{{row.code}}</td>
                                  <!-- <td>{{row.currency_code}}</td> -->
                                  <td>{{(row.invoice_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                  <td>{{(row.amount_os * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                  <td>{{(row.amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                  <td v-if="is_editing">
                                      <base-button v-if="is_editing" size="sm" icon type="danger" @click="deleteItem(index)"><i class="fas fa-trash-alt"></i ></base-button>
                                  </td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
                <!-- ITEMS END -->
                <!-- <b-row class="mt-3">
                    <b-col lg="12">
                        <base-button type="success" @click.native="onClickSave()" class="mr-4">
                            {{language_terms['SAVE']}}
                        </base-button>
                        <base-button type="primary" @click.native="clickOnBack">
                            {{language_terms['BACK']}}
                        </base-button>
                    </b-col>
                </b-row> -->
                <div class="floating-bar" v-if="(form.items.length > 0)">
                    <div class="floating-bar-container" align="center">
                        <b-button-group>
                            <b-button class="transparent-btn" @click="onClickEdit()"  v-if="(!is_editing && form.is_posted == 0 && form.is_void == 0)">
                                <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                            </b-button>
                            <b-button class="transparent-btn" v-if="is_editing"  @click="onClickSave()">
                                <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                            </b-button>
                            <b-button class="transparent-btn"  @click="clickOnBack()">
                                <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['BACK']}}
                            </b-button>
                        </b-button-group>
                    </div>
                </div>
              </card>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </template>
  <!--Must put this code to use auto complete component-->
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  
  <script>
  import { Select, Option,Table, TableColumn, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import axios from "axios";
  import { apiRoutes } from "../../../apiRoutes";
  import { authHeader } from "../../../global";
  import { mapState } from "vuex";
  import productLookup from "@/components/Autocomplete.vue";
  import tradeItemDespLookup from "@/components/Autocomplete.vue";
  import moment from "moment";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import Vue from 'vue';
  
  export default {
    data() {
      return {
        loadingCounter:0,
        title:"",
        currency_options:[],
        invoices:[],
        is_editing: false,   
        filter:{
            keyword:"",
            date_from:'',
            date_to:''
        },
        value: "",
        document_title: "",
        customers: [],
        selected_customer:null,
        form: {
          mode: 'DN',
          contact_id:'',
          contact_code:'',
          contact_name:'',
          reference:'',
          date:null,
          customer: {},
          currency_code: "SGD",
          remarks:"",
          remarks_internal:"",
          items: [],
          document: [],
        },
        row:{
          selected_invoice:null,
          code: null,
          currency: null,
          invoice_amount: null,
          amount_paid: null,
          amount:null
          },
      };
    },
    components: {
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        flatPicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        productLookup,
        tradeItemDespLookup,
    },
    computed: {
      ...mapState({
          document_total: state => state.sales.document_total,
          revisions: state => state.documentRevisions.revisions, 
          revision_is_created: state => state.documentRevisions.revision_created,
          revision_is_retrieved: state => state.documentRevisions.is_retrieved,
          revision_data: state => state.documentRevisions.data,
          is_approved: state => state.sales.is_approved,
          is_rejected: state => state.sales.is_rejected,
          auth_user:state => state.auth.auth_user,
          printouts: state => state.documentPrintouts.printouts,
          milestones: state => state.documentMilestones.milestones,
          sales_filter:state => state.sales.filter,
          sale_is_created: (state) => state.sales.is_created,
          sale_is_updated: (state) => state.sales.is_updated,
          business_units: (state) => state.customers.business_units,
          currencies: (state) => state.currencies.currencies,
          taxes: (state) => state.taxes.taxes,
          taxData: (state) => state.taxes.data,
          product_price: (state) => state.products.product_price,
          sale_doc: (state) => state.sales.document,
          language_terms: (state) => state.languages.language_terms,
          selected_lang: (state) => state.languages.selected_langauge,
          uom_list:state => state.products.uom_list, 
          Loading,
          [Select.name]: Select,
          [Option.name]: Option,
      })
    },
    async mounted() 
    {
      this.loadingCounter++
      let documnet_id = this.$route.params.id;
      this.loadDefaultOptions()

      if (documnet_id == "_new") 
      {
        this.title = this.language_terms['NEW_DEBIT_NOTE']
        this.setDefaults()
        this.is_editing = true
        this.form.date = moment().format("YYYY-MM-DD");
      } 
      else
      {  
        this.title = this.language_terms['DEBIT_NOTES'] + ' ' + [documnet_id]
        this.is_editing = false
        let id = this.$route.params.id
        await this.retrieveCNInvoice(id) 

        // this.document_mode = this.$route.query.mode;
        // if (this.type && documnet_id) 
        // {
        //   await this.retrieveDocument(documnet_id, this.type);
        // }
        //this.document_title = `${this.$props.title} (${documnet_id})`;
  
        await this.asyncFindCustomer(this.form.contact_code);
  
        let customer = {
          id: this.form.contact_id,
          code: this.form.contact_code,
          name: this.form.contact_name,
        };
  
        this.form.customer = customer;
      }
      this.loadingCounter--
    },
    watch:{
          language_terms: {
              handler(val){
                  this.updateBomFiledTerms()
                  this.updateTableLang()
              },
              deep: true
          }
    },
    methods: 
    {
      deleteItem(index)
        {
            this.form.items.splice(index, 1);
        },
      async onClickEdit()
        {
            this.is_editing = true
        },
      async onClickSave()
        {
            this.loadingCounter++
            let payload = this.form
            await axios
            .post(apiRoutes["AR_SAVE"], payload, authHeader())
            .then((response) => 
            {
                if (response.data.code == 1) {
                    this.form = response.data.data 
                    this.$router.push("/finance/ar-debit-notes")
                    let document_code  = response.data.msg.code
                    Vue.notify({group: 'notify', type: 'success', text: 'Debit Note (' + document_code + ')' + " has been saved!"
                    , max: 5, duration: 5000, speed: 300})
                } 
            })
            .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: 'Debit Note Saved Fail !', max: 5, duration: 5000, speed: 300,});
                }
            });                
            this.loadingCounter--
        },

      async onClickAddItem()
        {
            this.loadingCounter++
            if (this.row.code == null || this.row.code == '')
            {
                Vue.notify({group: 'notify', type: 'error', text: 'Invoice has to be selected', max: 5, duration: 5000, speed: 300})
            }

            else if (this.row.amount == null || this.row.amount == '')
            {
                Vue.notify({group: 'notify', type: 'error', text: 'Amount has to be entered', max: 5, duration: 5000, speed: 300})
            }
            else
            {
              let row = {
                  customer: this.form.customer,
                  date: this.form.date,
                  reference: this.form.reference,
                  currency: this.row.currency,
                  remarks: this.form.remarks,
                  remarks_internal: this.form.remarks_internal,
                  code:this.row.code.code,
                  amount: this.row.amount,
                  amount_paid: this.row.amount_paid,
                  invoice_amount: this.row.invoice_amount,
                  mode: 'DN'
              }
              
              let payload = row
              axios
              .post(apiRoutes["AR_RETRIEVE_INVOICE_DETAILS"], payload, authHeader())
              .then((response) => 
              {
                  if (response.data.code == 1) {
                    let i = response.data.data
                    row.currency_code = i.currency_code
                    row.invoice_amount = i.invoice_amount
                    row.amount_paid = i.amount_paid
                    row.amount_os = i.amount_os                   
                    this.form.items.push(row)
                    this.row.amount = null
                    
                  } 
              })
              .catch((error) => {
                  if (error.response) {
                      Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                  }
              });   
            }
            
            this.loadingCounter--
        },

      async loadDefaultOptions()
      {
          let payload = []
          await axios
          .post(apiRoutes["CURRENCIES_LIST"], payload, authHeader())
          .then((response) => 
          {
              if (response.data.code == 1) {
                  this.currency_options = response.data.data
              } 
              else 
                  Vue.notify({group: "notify", type: "error", text: response.data.msg, max: 5, duration: 5000, speed: 300,});
          
          })
          .catch((error) => {
              if (error.response) {
                  Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
              }
          });
      },

      async retrieveCNInvoice(code)
      {
        this.loadingCounter++
          let payload = {code:code, mode:'DN'}
          await axios
          .post(apiRoutes["AR_RETRIEVE"], payload, authHeader())
          .then((response) => 
          {
            if (response.data.code == 1) {
              this.form = response.data.data
            } 
            else 
            {
              alert('Failed');
            }
          })
          .catch((error) => {
            if (error.response) {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }
          });
          this.loadingCounter--
      },
      async setDefaults()
      {
        //this.document_title = "New " //+ this.$props.title;
        if(!this.form.date)
        {
          this.form.date = moment().format("YYYY-MM-DD");
        }
      },
      updateTableLang()
      {
      },

      invoiceNameWithCode ({ code }) {
          if(code)
              return `${code}`
      },
      productNameWithCode ({ name, code }) {
        if(name || code)
          return `${name} :: ${code}`
      },
      customerNameWithCode ({ name, code }) {
        if(name || code)
          return `${name} (${code})`
      },

      onSelectInvoice(obj)
        {
            if(obj.code)
            {
              this.retrieveInvoiceItems(obj.code)
            }
        },
      async retrieveInvoiceItems(code)
      {
        this.loadingCounter++

        if (code)
        {
          let payload = {code:code}
          axios.post(apiRoutes['AR_RETRIEVE_INVOICE_AMOUNTS'], payload, authHeader())
          .then(response => {
            if (response.data.code == 1) 
            {
              this.row.invoice_amount = response.data.data.invoice_amount
              this.row.amount_paid = response.data.data.amount_paid
            } 
            else 
            {
              this.row.invoice_amount = []
            }
          })
          .catch(error => {
            if (error.response) 
              Vue.notify({group: 'notify', type: 'error', text: error.response.data.msg, max: 5, duration: 5000, speed: 300})
          });
        }

        this.loadingCounter --
      },
      async onSelectCurrency()
      {
        this.form.items = []
        // this.row.code = {
        //   selected_invoice:null,
        //   code: null,
        //   currency: null,
        //   invoice_amount: null,
        //   amount_paid: null,
        //   amount:null
        //   }
          this.row = {
          selected_invoice:null,
          code: null,
          currency: null,
          invoice_amount: null,
          amount_paid: null,
          amount:null
          }
      },
      async onSelectCustomer(selectedOption) {
        if (selectedOption) 
        {
          this.form.contact_id = selectedOption.id
          if(selectedOption.id)
          {
            this.form.document_id = null
            this.form.contact_id = selectedOption.id;
            this.form.tax_code = selectedOption.customer_tax_code;
            this.form.currency_code = selectedOption.currency_code;
            this.form.customer_credit_term = selectedOption.customer_credit_term;
            this.form.customer_credit_limit = selectedOption.customer_credit_limit;
            this.form.customer_credit_limit_available = selectedOption.customer_credit_limit_available;
            this.form.attention_to = selectedOption.contact_person

            this.form.document = []
            this.form.items = []
            this.form.gross_amount = 0
            this.form.tax_amount = 0
            this.form.nett_amount = 0

            this.row.code = []
            this.form.currency_code = 'SGD'

            this.form.tax_rate_percent = this.taxData.rate_percent
          }
        }
      },
      limitText(count) {
        return `and ${count} other countries`;
      },
      clickOnBack()
      {
          this.$router.push("/finance/ar-debit-notes")
      },
      routeToMaster() 
      {
        this.$router.push("/finance/ar-debit-notes");
      },
      cancelDocument() 
      {
  
        if(this.$route.params.id == '_new')
        {
          this.routeToMaster()
        }
        else
        {
          location.reload();
        }
        
      },
      async asyncFindInvoices() 
      {
        // Invoice LookUp
        this.loadingCounter++

        let payload = {
          contact_id : this.form.contact_name.id, 
          currency_code : this.form.currency_code}
            //let pv = {"contact_id": {"operator":"=", "value": this.form.selected_customer.id}}
            await axios
                .post(apiRoutes["AR_RETRIEVE_INVOICES"], payload, authHeader())
                .then((response) => {
                if (response.data.code == 1) {
                    
                    this.invoices = response.data.data;
                } 
                else 
                {
                    this.invoices = [];
                }

                this.isLoading = false;
                })
                .catch((error) => {
                if (error.response) 
                {
                    Vue.notify({ group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300});} 
                    else 
                    {
                        console.log("Problem ", error);
                    }
                });
      this.loadingCounter--
    },
    async asyncFindCustomer(query) 
    {
      let pv = { value: query };
      await axios.post(apiRoutes["CUSTOMER_LOOKUP"], pv, authHeader()).then((response) => {
          if (response.data.code == 1) {
            this.customers = response.data.data;
          } else {
            this.customers = [];
          }

          this.loadingCounter--;
        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
        });
    },
    },
  };
  </script>
  <style>
    th.VueTables__sortable {
        color:rgb(255,255,255);
    }
    td.VueTables__row  {
        color:black
    }
    .v-data-table /deep/ .sticky-header {
      position: sticky;
      top: var(--toolbarHeight);
    }
    
    .v-data-table /deep/ .v-data-table__wrapper {
      overflow: unset;
    }
  </style>
  <style scoped>
  .marginCheck{
    margin-right:90px;
  }
   .float-button2
    {
  
      position:fixed;
      width:60px;
      height:60px;
      bottom:40px;
      /* background-color:#0C9; */
      background-color:#2dce89;
      color:#FFF;
      border-radius:50px;
      text-align:center;
      box-shadow: 2px 2px 3px #999;
    }
  /* .marginPlus{
    margin-right:220px;
  } */
  </style>